// format date like => 17 feb, 2023
export const dateFormat = 'DD MMM, YYYY';

// format date like => feb 17, 2023
export const brithanDateFormat = 'MMM DD, YYYY';

// format time and date like => 10:45 AM | 17 Feb, 2023
export const timeAndDate = 'hh:mm A | DD MMM, YYYY';

// format  date like => 2023
export const dateYear = 'YYYY';

// Image Repo url
export const PUBLIC_IMAGES_REPO =
  'https://dev.images.boostfloral.com/publicImagesRepo';

export const PAYMENTSTATUS = {
  canceled: 'CANCELED',
  processing: 'PROCESSING',
  requires_action: 'REQUIRES ACTION',
  requires_capture: 'REQUIRES CAPTURE',
  requires_confirmation: 'REQUIRES CONFIRMATION',
  requires_payment_method: 'REQUIRES PAYMENT METHOD',
  PAYMENT_PENDING: 'PENDING PAYMENT METHOD',
  succeeded: 'SUCCEEDED',
  FAILED: 'FAILED',
};

export const paymentStatusColor = {
  succeeded: '#4CAF50',
  canceled: '#dc3545',
  processing: '#ffc107',
  requires_action: '#ff9800',
  requires_capture: '#17a2b8',
  requires_confirmation: '#007bff',
  requires_payment_method: '#f44336',
  PAYMENT_PENDING: '#f0ad4e',
  disputed: '#c62828',
  refunded: '#007bff',
  partially_refunded: '#9c27b0',
  FAILED: '#eb0808',
};

export const COUNTRIES = [
  {
    name: 'United States',
    code: 'US',
  },
];

export const HELPSECTIONTOPICS = {
  METATITLE: 'METATITLE',
  METADESCRIPTION: 'METADESCRIPTION',
  METAKEYWORDS: 'METAKEYWORDS',
  METASOCIALMEDIA: 'METASOCIALMEDIA',
  METASOCIALIMAGE: 'METASOCIALIMAGE',
  CONFIGURESHOPSETTINGS: 'CONFIGURESHOPSETTINGS',
  PRODUCTTOPTAGS: 'PRODUCTTOPTAGS',
  LOCALDELIVERYONLY: 'LOCALDELIVERYONLY',
  DEACTIVATEPRODUCT: 'DEACTIVATEPRODUCT',
  HIDEFROMPRODUCTPAGE: 'HIDEFROMPRODUCTPAGE',
  MYSITE: 'MYSITE',
  HEROBANNERIMAGE: 'HEROBANNERIMAGE',
  GALLERYSECTION: 'GALLERYSECTION',
  WEBSITEEDITORINTRO: 'WEBSITEEDITORINTRO',
  UPDATINGPAGESANDSECTIONS: 'UPDATINGPAGESANDSECTIONS',
  ADDPRODUCTTAGS: 'ADDPRODUCTTAGS',
  DELIVERYCHARGESETTINGS: 'DELIVERYCHARGESETTINGS',
  ADDONS: 'ADDONS',
  PAYOUTAMOUNT: 'PAYOUTAMOUNT',
  CONTACTUS: 'CONTACTUS',
  TAGFILTER: 'TAGFILTER',
  BLACKOUTDATES: 'BLACKOUTDATES',
};

export const SUBSCRIPTIONSPLANS = {
  ESSENTIAL_MONTHLY: 'Essential_Monthly',
  ESSENTIAL_YEARLY: 'Essential_Yearly',
  PREMIUM_MONTHLY: 'Premium_Monthly',
  PREMIUM_YEARLY: 'Premium_Yearly',
  PREMIUM_MONTHLY_Managed: 'Premium_Monthly_Managed',
  PREMIUM_YEARLY_Managed: 'Premium_Yearly_Managed',
  STARTER: 'STARTER',
};
export const SUBSCRIPTIONSTATUS = {
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  ACTIVE: 'active',
};

export const TOTAL_PRELIVE_CHECKS = 13;

export const preLiveCheckList = [
  {
    title: 'Configure Ecommerce Shop Settings',
    helpSectionTrigger: HELPSECTIONTOPICS.CONFIGURESHOPSETTINGS,
    selector: ['defaultDeliveryCharge', 'taxRate', 'shopLogo'],
    status: (arr) => arr?.every((status) => status),
    subItems: [
      {
        title: 'Set your default delivery charge',
        selector: 'defaultDeliveryCharge',
        redirectUrl: '/shopInfo/orderSettings',
        status: (value) => value,
      },
      {
        title: 'Set your tax rate',
        selector: 'taxRate',
        redirectUrl: '/shopInfo/orderSettings',
        status: (value) => value,
      },
      {
        title: 'Upload shop logo',
        selector: 'shopLogo',
        redirectUrl: '/shopInfo/details/edit',
        status: (value) => value,
      },
      {
        title: 'Update regional settings',
        helperText:
          "This will be marked as completed upon your first click of 'Update' in regional settings.",
        selector: 'regionalSettingsUpdated', // Assuming you have a field for timezone
        redirectUrl: '/shopInfo/regionalSettings', // Define the URL for setting the timezone
        status: (value) => value, // Define how to check if timezone is set (true/false)
      },
    ],
  },
  {
    title: 'Products (Top Tags)',
    helpSectionTrigger: HELPSECTIONTOPICS.PRODUCTTOPTAGS,
    status: (arr) => arr?.every((status) => status),
    selector: ['roseTag', 'favoriteTag', 'topRatedTag'],
    subItems: [
      {
        title: 'Tag a product as (Rose)',
        selector: 'roseTag',
        redirectUrl: '/settings/products',
        status: (value) => value,
      },
      {
        title: 'Tag a product as (Favorite)',
        redirectUrl: '/settings/products',
        selector: 'favoriteTag',
        status: (value) => value,
      },
      {
        title: 'Tag a product as (Top Rated)',
        redirectUrl: '/settings/products',
        selector: 'topRatedTag',
        status: (value) => value,
      },
    ],
  },
  {
    title: 'Financial Onboarding (Stripe)',
    selector: [
      'stripeAccountStatus',
      'stripeAccountDetailSubmitted',
      'stripeAccountChargesEnabled',
      'stripeAccountPayoutsEnabled',
    ],
    status: (arr) => arr?.every((status) => status),
    subItems: [
      {
        title: 'Business Identity Information',
        selector: 'stripeAccountDetailSubmitted',
        redirectUrl: '/shopInfo/financials',
        status: (value) => value,
      },
      {
        title: 'Configure Online Payments',
        selector: 'stripeAccountChargesEnabled',
        redirectUrl: '/shopInfo/financials',
        status: (value) => value,
      },
      {
        title: 'Bank Account for Payouts',
        selector: 'stripeAccountPayoutsEnabled',
        redirectUrl: '/shopInfo/financials',
        status: (value) => value,
      },
    ],
  },
  {
    title: 'Add your Domain and update Name Servers',
    selector: ['domainRegistered', 'nameserversUpdated'],
    status: (arr) => arr?.every((status) => status),
    subItems: [
      {
        title: 'Add your domain name',
        selector: 'domainRegistered',
        redirectUrl: '/settings/createwebsite',
        status: (value) => value,
      },
      // {
      //   title: 'Website hosting Activated',
      //   selector: 'usingWebHosting',
      //   status: (value) => value,
      // },
      {
        title: 'Name servers configured',
        selector: 'nameserversUpdated',
        status: (value) => value,
        extraContent: (item, callback) => {
          callback(item);
        },
      },
    ],
  },
  {
    title: 'Choose a subscription',
    selector: ['floristSubscriptionDTO'],
    redirectUrl: '/billing',
    status: (arr) =>
      arr?.every(
        (item) =>
          item?.status?.toLowerCase() === SUBSCRIPTIONSTATUS.ACTIVE &&
          item?.subscriptionName !== SUBSCRIPTIONSPLANS.STARTER,
      ),
  },
];

export const SUBSCRIPTIONPAYMENTSTATUS = {
  PENDING: 'pending',
  INPROGRESS: 'inprogress',
  SUCCESS: 'success',
  DONE: 'done',
};

export const SCHEDULE_TYPE = [
  {
    label: 'Daily',
    value: 'DAILY',
  },
  {
    label: 'Weekly',
    value: 'WEEKLY',
  },
  {
    label: 'Monthly',
    value: 'MONTHLY',
  },
];

export const DAYS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
];

export const WEEK_DAYS = [
  { label: 'Sunday', label1: 'SUN', value: 'SUNDAY' },
  { label: 'Monday', label1: 'MON', value: 'MONDAY' },
  { label: 'Tuesday', label1: 'TUE', value: 'TUESDAY' },
  { label: 'Wednesday', label1: 'WED', value: 'WEDNESDAY' },
  { label: 'Thursday', label1: 'THU', value: 'THURSDAY' },
  { label: 'Friday', label1: 'FRI', value: 'FRIDAY' },
  { label: 'Saturday', label1: 'SAT', value: 'SATURDAY' },
];

export const view_websites = [
  {
    name: 'can_view_order',
    link: 'orders',
  },
  {
    name: 'can_view_website',
    link: 'editTemplate',
  },
  {
    name: 'can_view_website',
    link: 'edittemplate',
  },
  {
    name: 'can_view_website',
    link: 'settings/createwebsite',
  },
  {
    name: 'can_view_inquiries',
    link: 'settings/inquiries',
  },
  {
    name: 'can_view_addons',
    link: 'settings/addons',
  },
  {
    name: 'can_view_customer',
    link: 'customers',
  },
  {
    name: 'can_view_dashboard',
    link: 'dashboard',
  },
  {
    name: 'can_view_shop_info',
    link: 'shopInfo/details',
  },
  {
    name: 'can_view_financials',
    link: 'shopInfo/financials',
  },
  {
    name: 'can_view_shop_settings',
    link: 'shopInfo/orderSettings',
  },
  {
    name: 'can_view_regional_settings',
    link: 'shopInfo/regionalSettings',
  },
  {
    name: 'can_view_policy',
    link: 'shopInfo/policy',
  },
  {
    name: 'can_view_integrations',
    link: 'shopInfo/integrations',
  },
  {
    name: 'can_view_roles',
    link: 'shopInfo/role',
  },
  {
    name: 'can_view_users',
    link: 'shopInfo/users',
  },
  {
    name: 'can_view_billings',
    link: 'billing',
  },
  {
    name: 'can_view_gallery',
    link: 'settings/gallery-settings',
  },
  {
    name: 'can_view_inventory_insights_dashboard',
    link: '/settings/inventory/Insights',
  },
  {
    name: 'can_view_catalog_insights_dashboard',
    link: '/settings/catalog/insights',
  },
  {
    name: 'can_view_reports',
    link: 'reports',
  },
  {
    name: 'can_view_deliveries',
    link: 'deliveries',
  },
  {
    name: 'can_view_products',
    link: '/settings/products',
  },
  {
    name: 'can_view_catalog',
    link: '/settings/products/catalog',
  },
].filter(Boolean);

export const vendor_routes = [
  {
    name: 'can_view_florists',
    link: 'admin/florists',
  },
  {
    name: 'can_view_product_settings',
    link: '/settings/product/settings',
  },
];


export const SUBSCRIPTIONSTATUS2 = {
  incomplete: 'Incomplete',
  incomplete_expired: 'Incomplete Expired',
  trailing: 'Trailing',
  active: 'Active',
  past_due: 'Past Due',
  canceled: 'Canceled',
  unpaid: 'Unpaid',
  paused: 'Paused',
  done : 'Done'
};